import { Box, Typography, Alert, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { CheckCircle, Construction } from '@mui/icons-material';

export function SectionHeader({ icon, title, subtitle }: { icon: React.ReactNode; title: string; subtitle: string }) {
  return (
    <Box display="flex" alignItems="flex-start" gap={2} mb={3}>
      <Box sx={{ color: 'primary.main', mt: 0.5 }}>{icon}</Box>
      <Box>
        <Typography variant="h5" fontWeight={600}>{title}</Typography>
        <Typography variant="body2" color="text.secondary">{subtitle}</Typography>
      </Box>
    </Box>
  );
}

export function TodoBanner({ message }: { message: string }) {
  return (
    <Alert severity="warning" icon={<Construction />} sx={{ mb: 2 }}>
      <Typography variant="body2">
        <strong>Documentation pending:</strong> {message}
      </Typography>
    </Alert>
  );
}

export function Done({ children }: { children: React.ReactNode }) {
  return (
    <ListItem disableGutters>
      <ListItemIcon sx={{ minWidth: 32 }}><CheckCircle color="success" fontSize="small" /></ListItemIcon>
      <ListItemText primary={<Typography variant="body2">{children}</Typography>} />
    </ListItem>
  );
}

export function Todo({ children }: { children: React.ReactNode }) {
  return (
    <ListItem disableGutters>
      <ListItemIcon sx={{ minWidth: 32 }}><Construction color="warning" fontSize="small" /></ListItemIcon>
      <ListItemText primary={<Typography variant="body2" color="text.secondary">{children}</Typography>} />
    </ListItem>
  );
}

export function CodeBlock({ children }: { children: string }) {
  return (
    <Box component="pre" sx={{
      bgcolor: '#1e1e1e', color: '#d4d4d4', p: 2, borderRadius: 1,
      fontSize: '0.8rem', overflowX: 'auto', fontFamily: 'monospace', my: 1,
    }}>
      {children}
    </Box>
  );
}
